import PropertiesPage from "../sections/propertiesPage";
import Footer from "../sections/footer";

function Properties() {
  return (
    <div>
      <PropertiesPage />
      <Footer />
    </div>
  );
}

export default Properties;
